import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppButton from "@/components/WhatsAppButton";
import GrainOverlay from "@/components/GrainOverlay";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import CityLanding from "@/pages/CityLanding";
import Admin from "@/pages/Admin";

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100); return; }
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);
  return null;
}

function App() {
  useLenis();
  useEffect(() => { document.title = "Synergy Solar - Solar EPC in North India"; }, []);
  return (
    <div className="App min-h-screen bg-cream">
      <BrowserRouter>
        <GrainOverlay />
        <Navbar />
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/solar/:slug" element={<CityLanding />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <ChatWidget />
        <WhatsAppButton />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
